/*
Light Bulbs
*/
import filters from '@/modules/standardItems/schemas/finish/filters'
import headers from '@/modules/standardItems/schemas/finish/headers'
import form from '@/modules/standardItems/schemas/finish/form'

const name = 'Light Bulbs'
const id = 'zUi2nB2ih6Pk8BuAHGg8'

export default {
  name,
  id,
  filters,
  headers,
  form
}
